<div class="se-suggestion-selector__background">
    <div class="se-suggestion-selector" (keydown.esc)="onClose()">
        <div *ngFor="let suggestion of suggestions; index as i"
             [id]="'suggestion-div-' + i"
             class="se-suggestion-selector-option"
             [ngClass]="{'se-suggestion-selector-option-preselected' : suggestion === preSelectedSuggestion}"
             (click)="onSelect(suggestion)">
            <div [innerHtml]="createSuggestionHTML(suggestion,i+1)"></div>
        </div>
    </div>
</div>
